import React, { useState, useEffect } from 'react';
import { fetchCategories } from '../../http/categoryAPI';
import { fetchBooking, updateBooking } from '../../http/bookingAPI';
import BookingDatePicker from './BookingDatePicker';
import '../../styles/bookingForm.scss';

const UpdateBookingForm = ({ bookingId, onUpdated, onCancel }) => {
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({
    patientName: '',
    patientSurname: '',
    phone1: '',
    phone2: '',
    visitDate: '',
    age: '',
    notes: '',
    categoryId: ''
  });
  const [loading, setLoading] = useState(true);
  
  // Load categories & booking data
  useEffect(() => {
    const loadData = async () => {
      try {
        const [categoriesData, bookingData] = await Promise.all([
          fetchCategories(),
          fetchBooking(bookingId)
        ]);
        setCategories(categoriesData);
        setFormData({
          patientName: bookingData.patientName || '',
          patientSurname: bookingData.patientSurname || '',
          phone1: bookingData.phone || '',
          phone2: bookingData.phone || '',
          visitDate: bookingData.visitDate || '',
          age: bookingData.age || '',
          notes: bookingData.notes || '',
          categoryId: bookingData.categoryId || ''
        });
      } catch (error) {
        console.error('Error loading booking or categories:', error);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [bookingId]);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateBooking(bookingId, formData);
      alert('Booking updated successfully!');
      if (onUpdated) onUpdated();
    } catch (error) {
      console.error('Error updating booking:', error);
      alert('Failed to update booking. Please try again.');
    }
  };

  if (loading) {
    return <p>Loading booking data...</p>;
  }

  return (
    <div className="container mt-5">
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <input
            type="text"
            name="patientName"
            value={formData.patientName}
            onChange={handleChange}
            required
            className="form-control"
            placeholder="Name"
          />
        </div>

        <div className="mb-3">
          <input
            type="text"
            name="patientSurname"
            value={formData.patientSurname}
            onChange={handleChange}
            required
            className="form-control"
            placeholder="Surname"
          />
        </div>

        <div className="mb-3">
          <input
            type="tel"
            name="phone1"
            value={formData.phone1}
            onChange={handleChange}
            required
            className="form-control"
            placeholder="Phone"
          />
        </div>

        <div className="mb-3">
          <input
            type="tel"
            name="phone2"
            value={formData.phone2}
            onChange={handleChange}
            required
            className="form-control"
            placeholder="Phone"
          />
        </div>

        <BookingDatePicker formData={formData} setFormData={setFormData} />

        <div className="mb-3">
          <input
            type="number"
            name="age"
            value={formData.age}
            onChange={handleChange}
            className="form-control"
            placeholder="Age"
          />
        </div>

        <div className="mb-3">
          <textarea
            name="notes"
            value={formData.notes}
            onChange={handleChange}
            className="form-control"
            placeholder="Additional Notes"
          ></textarea>
        </div>

        <div className="mb-3">
          <select
            name="categoryId"
            value={formData.categoryId}
            onChange={handleChange}
            required
            className="form-control"
          >
            <option value="">Select a Department</option>
            {categories.map(category => (
              <option key={category.id} value={category.id}>
                {category.nameEN}
              </option>
            ))}
          </select>
        </div>

        <div className="d-flex gap-2">
          <button
            type="submit"
            className="ant-btn css-dev-only-do-not-override-mc1tut ant-btn-default ant-btn-color-default ant-btn-variant-outlined booking"
          >
            <span>Update Booking</span>
          </button>
          {onCancel && (
            <button
              type="button"
              onClick={onCancel}
              className="ant-btn ant-btn-default"
            >
              Cancel
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default UpdateBookingForm;
